type TTooltipEntry = {
  tooltip: string;
  tags: string[];
};

const productModelTooltips: Record<string, TTooltipEntry> = {
  casual: {
    tooltip:
      'Designed for casual users with simple gameplay, monetized primarily through in-app purchases with a small portion of ad revenue, typically accounting for 25–30% of monthly revenue.',
    tags: ['Casual', '休闲'],
  },
  exclusive_access: {
    tooltip:
      'Games accessible only to members of external subscription services, typically offering features and quality comparable to premium titles.',
    tags: ['Exclusive Access', '特定权限', 'Subscription-only Access'],
  },
  hybrid_casual: {
    tooltip:
      'Combines casual gameplay with light mid-core meta. Monetization typically includes currency bundles, progression packs, interstitials, and rewarded ads, with ads accounting for around 50% of monthly revenue.',
    tags: ['Hybridcasual', 'Hybrid Casual', '混合休闲'],
  },
  hypercasual: {
    tooltip:
      'Low-cost, short-term retention games featuring simple and repetitive mechanics, monetized almost entirely through ads, which represent nearly 100% of monthly revenue.',
    tags: ['Hypercasual', 'Hyper Casual', '超休闲'],
  },
  mid_core: {
    tooltip:
      'Targeting players between casual and hardcore segments, with deeper gameplay and longer progression, relying on long-term retention and in-app purchases.',
    tags: ['Mid-core', 'Midcore', '中度'],
  },
};

const sensorTagTooltips = {
  sensor_tower_tag_product_model: productModelTooltips,
};

export default sensorTagTooltips;
